import { Microdata } from 'components/microdata';
import { SchemaOrgType } from 'components/microdata/microdata.component';
import { Card, Spacer } from 'components/ui-kit';
import React from 'react';
import { InfoRow } from './info-row.component';
import styles from './map.module.scss';

type TContactData = {
  name: string;
  address: {
    streetAddress: string;
    postalCode: string;
    addressLocality: string;
  };
  email: string;
  schedule: string;
  telephone: string;
  scheduleTimezone: string;
  url: string;
  logo: string;
};

const CONTACT_DATA: TContactData = {
  name: 'Точка',
  address: {
    streetAddress: 'ул. Сакко и\xa0Ванцетти, 61, Бизнес-центр «Венский Дом»',
    postalCode: '620014',
    addressLocality: 'г. Екатеринбург',
  },
  email: 'shop@tochka.com',
  schedule: 'Пн-Пт 07:00-18:00',
  telephone: '8 800 2000 024',
  scheduleTimezone: 'Europe/Moscow',
  url: process.env.SITE_URL || 'https://shop.tochka.com',
  logo: '/favicon-32x32.png',
};

const getFullAddressFromData = (data: TContactData): string => {
  const {
    address: { addressLocality, postalCode, streetAddress },
  } = data;

  return `${postalCode}, ${addressLocality}, ${streetAddress}`;
};

const { address, ...contactData } = CONTACT_DATA;

export const ContactInfo = (): JSX.Element => {
  return (
    <>
      <Card className={styles.contactInfo}>
        <InfoRow title="Адрес" content={getFullAddressFromData(CONTACT_DATA)} />
        <Spacer size={24} />
        <InfoRow title="Почта для обращений" content={contactData.email} />
        <Spacer size={24} />
        <InfoRow
          title="Режим работы"
          content={contactData.schedule + ' (МСК)'}
        />
        <Spacer size={24} />
        <InfoRow
          title="Телефон для экстренных случаев"
          content={contactData.telephone}
        />
      </Card>

      <Microdata type={SchemaOrgType.Organization} items={contactData}>
        <Microdata type={SchemaOrgType.PostalAddress} items={address} />
      </Microdata>
    </>
  );
};
